import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { LotteryResult } from '..';
import { LotteryHeaderContainer } from '../../../LotteryHeaderContainer/LotteryHeaderContainer';
import type { LotteryDrawResult } from '../../types';

type ResultsExtraHeaderProps = ComponentProps<typeof LotteryHeaderContainer> & {
  title: string;
  drawingDate: string;
  result: LotteryDrawResult;
};

const HEADER_CONTAINER_OPTIONS = {
  decorationShine: 'bottom-24 right-13',
  decorationTopRight: '-top-14',
} as const;

function ResultsExtraHeader({ className, lotteryName, title, drawingDate, result, ...props }: ResultsExtraHeaderProps) {
  if (typeof result === 'undefined') return null;

  const { numbers, extraNumbers } = result;

  const classes = {
    container: twMerge(`flex flex-col gap-y-2 h-auto p-5 rounded-lg`, className),
    text: `self-start px-4`,
  };

  return (
    <LotteryHeaderContainer {...props} lotteryName={lotteryName} className={classes.container} options={HEADER_CONTAINER_OPTIONS}>
      <h5 className={classes.text}>{title}</h5>
      <p className={classes.text}>{drawingDate}</p>
      <LotteryResult result={{ numbers, extraNumbers }} lotteryName={lotteryName} className="light" />
    </LotteryHeaderContainer>
  );
}

export { ResultsExtraHeader };
